/* eslint-disable no-unused-vars */
import React, { useEffect, useState, useRef } from "react";
import styled from "styled-components/macro";
import { NavLink, useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import * as Yup from "yup";

import { DateTimePicker } from "@mui/lab";
import {
  CardContent,
  Grid,
  Link,
  Breadcrumbs as MuiBreadcrumbs,
  Card as MuiCard,
  Paper as MuiPaper,
  TextField,
  Typography,
  FormControl,
  Button,
  Snackbar,
  Alert,
  Autocomplete,
} from "@mui/material";
import { spacing } from "@mui/system";
import axios from "../../CustomAxios";
import { Formik } from "formik";
import Loading from "../components/Loading";

const Card = styled(MuiCard)(spacing);

const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);

const Paper = styled(MuiPaper)(spacing);

function FormDetails({ apUsers, jobs }) {
  const [err, setErr] = useState("");
  const [success, setSuccess] = useState(false);
  const [rows, setRows] = useState([]);
  const [loader, setLoader] = useState(false);
  const navigate = useNavigate();
  const snackRef = useRef(null);

  const [state, setState] = useState({
    open: false,
    vertical: "top",
    horizontal: "center",
  });
  const { vertical, horizontal, open } = state;
  const handleClick = (newState) => () => {
    setState({ open: true, ...newState });
  };
  const handleClose = () => {
    setState({ ...state, open: false });
  };

  const submit = async (values, resetForm) => {
    try {
      setLoader(true);
      const userData = JSON.parse(localStorage.getItem("AuthData"));
      const config = {
        headers: {
          Authorization: "Bearer " + userData.access_token,
        },
      };
      const { data } = await axios.post(
        `/api/v1/${userData.type}/tasks/`,
        {
          title: values.title,
          description: values.description,
          assigned_to: values.assigned_to,
          associated_job: values.associated_job,
          deadline: values.deadline,
        },
        config
      );
      if (data.success) {
        setLoader(false);
        setSuccess(true);
        setErr("");
        snackRef.current.click();
        resetForm({ values: "" });
        setRows([]);
        navigate("/dashboard/tasks/", {
          state: { success: true, message: "Task Created Successfully" },
        });
      }
    } catch (e) {
      setLoader(false);
      if (e.response.data.error) {
        setErr(e.response.data.error);
      } else {
        setErr("Server Error");
      }
      snackRef.current.click();
    }
  };

  useEffect(() => {
    console.log(err);
  }, [err]);

  return (
    <>
      <Formik
        initialValues={{
          title: "",
          description: "",
          assigned_to: "",
          associated_job: "",
          deadline: "",
          submit: false,
        }}
        validationSchema={Yup.object().shape({
          title: Yup.string().required("Title is required"),
          assigned_to: Yup.string().required("Assignee is required"),
          associated_job: Yup.string(),
        })}
        onSubmit={async (
          values,
          { setErrors, setStatus, setSubmitting, resetForm }
        ) => {
          try {
            submit(values, resetForm);
          } catch (error) {
            const message = error.message || "Something went wrong";
            setStatus({ success: false });
            setErrors({ submit: message });
            setSubmitting(false);
          }
        }}
      >
        {({
          errors,
          setFieldValue,
          handleBlur,
          handleChange,
          handleSubmit,
          isSubmitting,
          touched,
          values,
        }) => (
          // <></>
          <form noValidate onSubmit={handleSubmit} autoComplete="off">
            <Button
              ref={snackRef}
              style={{ display: "none" }}
              onClick={handleClick({ vertical: "top", horizontal: "center" })}
            >
              Click
            </Button>
            <Snackbar
              anchorOrigin={{ vertical, horizontal }}
              open={open}
              onClose={handleClose}
              key={vertical + horizontal}
            >
              {err ? (
                <Alert mt={2} mb={4} severity="error">
                  {err}
                </Alert>
              ) : success ? (
                <Alert mt={2} mb={4} severity="success">
                  Task created Successfully
                </Alert>
              ) : null}
            </Snackbar>
            {!loader ? (
              <Card mb={6}>
                <CardContent>
                  <Paper elevation={3} style={{ padding: "2%" }}>
                    <Grid container spacing={5}>
                      <Grid item xs={12} lg={12} md={12}>
                        <Typography variant="h6" gutterBottom>
                          Create Task
                        </Typography>
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <Grid container spacing={4}>
                          <Grid item xs={12} md={12} lg={12}>
                            <TextField
                              fullWidth
                              name="title"
                              value={values.title}
                              onBlur={handleBlur}
                              onChange={handleChange}
                              error={Boolean(touched.title && errors.title)}
                              id="search-field"
                              label="Title * "
                              helperText={touched.title && errors.title}
                            />
                          </Grid>
                          <Grid item xs={12} lg={12} md={12}>
                            <FormControl
                              error={Boolean(
                                touched.required_date && errors.required_date
                              )}
                              fullWidth
                            >
                              <DateTimePicker
                                name="deadline"
                                renderInput={(props) => (
                                  <TextField {...props} />
                                )}
                                label="Deadline"
                                value={values.deadline || null}
                                onChange={(newValue) => {
                                  let selectedDate = newValue;
                                  var month = (
                                    "0" + parseInt(selectedDate?.getMonth() + 1)
                                  ).slice(-2);
                                  var day = (
                                    "0" + parseInt(selectedDate?.getDate())
                                  ).slice(-2);
                                  var hour = parseInt(selectedDate.getHours());
                                  var minute = parseInt(
                                    selectedDate.getMinutes()
                                  );
                                  let date =
                                    selectedDate?.getFullYear() +
                                    "-" +
                                    month +
                                    "-" +
                                    day +
                                    ":" +
                                    hour +
                                    ":" +
                                    minute;
                                  setFieldValue("deadline", date);
                                }}
                                onBlur={handleBlur}
                              />
                            </FormControl>
                          </Grid>

                          <Grid item xs={12} md={12} lg={12}>
                            <FormControl
                              fullWidth
                              error={Boolean(
                                touched.assigned_to && errors.assigned_to
                              )}
                            >
                              <Autocomplete
                                id="combo-box-demo"
                                options={apUsers}
                                value={values?.assigned_to?.name}
                                onChange={(event, newValue) => {
                                  setFieldValue(
                                    "assigned_to",
                                    newValue?._id || ""
                                  );
                                  //   getApUsers();
                                }}
                                inputValue={values?.assigned_to?.name}
                                onBlur={handleBlur}
                                getOptionLabel={(option) => option?.name}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    error={Boolean(
                                      touched.assigned_to && errors.assigned_to
                                    )}
                                    helperText={
                                      touched.assigned_to && errors.assigned_to
                                    }
                                    label="Assign to * "
                                  />
                                )}
                              />
                            </FormControl>
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <Grid container spacing={2}>
                          <Grid item xs={12} md={12}>
                            <FormControl
                              fullWidth
                              error={Boolean(
                                touched.associated_job && errors.associated_job
                              )}
                            >
                              <Autocomplete
                                id="combo-box-demo"
                                options={jobs}
                                value={values?.associated_job?.job_id}
                                onChange={(event, newValue) => {
                                  setFieldValue(
                                    "associated_job",
                                    newValue?._id || ""
                                  );
                                }}
                                inputValue={values?.associated_job?.job_id}
                                onBlur={handleBlur}
                                getOptionLabel={(option) => option?.job_id}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    error={Boolean(
                                      touched.associated_job &&
                                        errors.associated_job
                                    )}
                                    helperText={
                                      touched.associated_job &&
                                      errors.associated_job
                                    }
                                    label="Assign to Job "
                                  />
                                )}
                              />
                            </FormControl>
                          </Grid>
                          <Grid item xs={12} md={12} lg={12}>
                            <TextField
                              fullWidth
                              multiline
                              rows={5}
                              name="description"
                              value={values.description}
                              onBlur={handleBlur}
                              onChange={handleChange}
                              error={Boolean(
                                touched.description && errors.description
                              )}
                              id="search-field"
                              label="Description"
                              helperText={
                                touched.description && errors.description
                              }
                            />
                          </Grid>
                        </Grid>
                      </Grid>

                      <Grid item xs={12} md={12} lg={12}>
                        <Button
                          type="submit"
                          style={{ textAlign: "center", float: "right" }}
                          mr={2}
                          variant="contained"
                          color="primary"
                          disabled={isSubmitting}
                        >
                          Create Task
                        </Button>
                      </Grid>
                    </Grid>
                  </Paper>
                </CardContent>
              </Card>
            ) : (
              <Loading />
            )}
          </form>
        )}
      </Formik>
    </>
  );
}

const getApUsersAndJobs = async (setApUsers, setJobs, setLoader) => {
  try {
    const userData = JSON.parse(localStorage.getItem("AuthData"));
    const config = {
      headers: {
        Authorization: "Bearer " + userData.access_token,
      },
    };
    let url = `/api/v1/${userData?.type}/tasks/get-apusers?page=1&limit=1000`;

    const apUsers = await axios.get(url, config);
    if (apUsers.data.success) {
      let finalData = apUsers.data.data.data;

      if (userData.type === "super_admin") {
        let user = {
          name: "super_admin",
          _id: userData.user_id,
        };
        finalData.push(user);
      }

      let presentUserIndex = finalData.findIndex(
        (u) => u._id === userData.user_id
      );
      if (presentUserIndex >= 0) {
        finalData[presentUserIndex].name = "Super Admin";
        finalData.forEach(function (item, i) {
          if (item._id === userData.user_id) {
            finalData.splice(i, 1);
            finalData.unshift(item);
          }
        });
      }
      setApUsers(finalData);
    }
    const { data } = await axios.get(
      `/api/v1/${userData?.type}/tasks/get-jobs?limit=1000`,
      config
    );
    if (data.success) {
      setJobs(data.data.data);
    }
    setLoader(false);
  } catch (e) {
    setLoader(false);
    console.log(e);
  }
};

function CreateTask() {
  const [jobs, setJobs] = useState([]);
  const [loader, setLoader] = useState(true);
  const [apUsers, setApUsers] = useState([]);

  useEffect(() => {
    getApUsersAndJobs(setApUsers, setJobs, setLoader);
  }, []);
  if (!loader) {
    return (
      <React.Fragment>
        <Helmet title="Alpha Plus" />
        <Grid
          justifyContent="space-between"
          alignItems="center"
          container
          spacing={10}
          mb={4}
        >
          <Grid item>
            <Typography
              variant="h4"
              gutterBottom
              display="inline"
              sx={{ fontWeight: 600 }}
              color="primary"
            >
              CREATE TASK
            </Typography>
          </Grid>
          <Grid item>
            <Breadcrumbs aria-label="Breadcrumb" mt={2}>
              <Link component={NavLink} to="/dashboard/tasks">
                Dashboard
              </Link>
              <Link component={NavLink} to="/dashboard/tasks">
                Tasks
              </Link>
              <Typography> Create Task</Typography>
            </Breadcrumbs>
          </Grid>
        </Grid>

        <Grid container spacing={6}>
          <Grid item xs={12}>
            <FormDetails apUsers={apUsers} jobs={jobs} />
          </Grid>
        </Grid>
      </React.Fragment>
    );
  } else {
    return <Loading />;
  }
}

export default CreateTask;
